module.exports = __webpack_public_path__ + "images/emoji/bear.2be19976d38809780da0.png";